import React, { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { saveArtFormDataAC } from "../../store/actions/builderActions"
import { AppButton } from "../common/button/AppButton"
import { Centered } from "../common/centered/Centered"
import { CustomH2 } from "../common/customH2/CustomH2"
import { AppFileInput } from "../common/input/AppFileInput"
import { AppLink } from "../common/link/AppLink"
import styles from './Art.module.css'

export const Art = () => {
    const { register, watch, handleSubmit } = useForm()
    const { art } = useSelector(state => state.builder)
    const [image, setImage] = useState()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        setImage(art)
    }, [])


    useEffect(() => {
        const subscription = watch(values => {
            setImage(values.art[0])
        })
        return () => subscription.unsubscribe()
    }, [watch])

    const onSubmit = (formData) => {
        dispatch(saveArtFormDataAC(formData.art[0]))
        navigate('/builder/slices')
    }

    return <Centered>
        <CustomH2>Add Cover Art</CustomH2>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div style={{ height: '50px' }}>
                <AppFileInput
                    register={register}
                    field='art'
                    accept='image/jpg, image/jpeg'
                />
            </div>
            {image && <img
                className={styles.image}
                src={URL.createObjectURL(image)} />}
            <div>
                <AppLink to='/builder/credits'>Go Back</AppLink>
                <AppButton
                    type='submit'
                    value='next'
                />
                <AppLink to='/builder/slices'>Skip</AppLink>
            </div>
        </form>
    </Centered>
}